<app-asset-vehicle-details></app-asset-vehicle-details>
